import type { GroupStatus } from "./types";

/**
 * Get status chip color and label based on group status
 */
export const getStatusChip = (status: GroupStatus) => {
  if (status === "completed") {
    return { color: "success" as const, label: "Completed" };
  }
  if (status === "pending") {
    return { color: "info" as const, label: "Pending" };
  }
  if (status === "active") {
    return { color: "primary" as const, label: "Active" };
  }
  return { color: "warning" as const, label: "Active & Unpaid" };
};

/**
 * Format a number as USD currency
 */
export const formatCurrency = (amount: number | undefined): string => {
  if (amount === undefined) {
    return "";
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

